// Lien vers un fichier protégé de l'API (export, modèle, étiquette…).
// Remplace <a href={api.xxxUrl(...)} download> : un lien direct n'envoie pas
// le jeton → l'API répond « Token d'authentification manquant ». Ici le
// fichier est récupéré avec le jeton, puis téléchargé (ou ouvert dans un
// onglet si newTab). Mêmes props visuelles qu'un <a>.
import api from "../services/api";
import { downloadProtectedFile, openBlobInNewTab } from "../utils/openBlob";

export default function ProtectedLink({ url, newTab = false, children, ...props }) {
  const onClick = (e) => {
    e.preventDefault();
    if (newTab) openBlobInNewTab(async () => (await api.fetchFile(url)).blob);
    else downloadProtectedFile(() => api.fetchFile(url));
  };
  return <a href="#download" {...props} onClick={onClick}>{children}</a>;
}
